import SV from 'server-vars';
import { VisitCountModel } from 'dibs-visit-tracking';

import User from '../../models/User';
import { isPageType, pageTypes, autoModalHelpers } from 'dibs-buyer-layout/src/entries/index';
import MultiplePdpVisitsModal from '../../../newPdp/components/MultiplePdpVisitsModal/MultiplePdpVisitsModal';
import {
    storePdpVisit,
    wasPdpVisitedMultipleTimes,
} from '../../../newPdp/components/MultiplePdpVisitsModal/multiplePdpVisitsModalHelpers.es';
import {
    SAME_PDP,
    AUTO,
} from '../../../newPdp/components/MultiplePdpVisitsModal/multiplePdpVisitsModalConstants.es';
import { createItemForAutoModal } from '../../components/AutoModal/autoModalHelpers.es';
import { benefitsModalTest, benefitsModalShow } from '../benefitsModalHelper.es';
const { setModalShown, wasModalShown, loadAutoModal } = autoModalHelpers;

const { PAGE_TYPE } = pageTypes;
const isPdp = isPageType(PAGE_TYPE.PDP);
const isLoggedIn = User.loggedIn();

const canShowAutoModal = () => {
    const visitCountModel = new VisitCountModel();
    return visitCountModel.get('session') === visitCountModel.get('regPromptLimit');
};

const isPdpAvailable = () => SV.get('rawResult.status') !== 'UNAVAILABLE';

const getModalTypeToShow = () => {
    if (!isLoggedIn && isPdp && isPdpAvailable()) {
        const itemId = SV.get('rawResult.id');

        storePdpVisit({ itemId });

        if (!wasModalShown()) {
            if (wasPdpVisitedMultipleTimes({ itemId })) {
                return SAME_PDP;
            } else if (canShowAutoModal()) {
                return AUTO;
            }
        }
    }

    return null;
};

const openModal = ({ context, modalType }) => {
    setModalShown();

    loadAutoModal({
        AutoModal: MultiplePdpVisitsModal,
        modalProps: {
            modalType,
            item: createItemForAutoModal(SV.get('rawResult')),
            context,
        },
    });
};

export const multiplePdpVisitsModalRule = ({ context }) => {
    const modalType = getModalTypeToShow();

    if (modalType) {
        return benefitsModalTest({ modalType })
            .then(() => {
                benefitsModalShow();
                return Promise.resolve({ success: true, type: 'benefitsModal' });
            })
            .catch(() => {
                openModal({ context, modalType });
                return Promise.resolve({ success: true, type: 'multiplePdpVisitsModal' });
            });
    }

    return Promise.resolve();
};




// WEBPACK FOOTER //
// ./assets/js/global/notifications/rules/multiplePdpVisitsRule.es.js